import React from 'react'
import { Box, Progress } from '@mantine/core'

interface ProgressCarProps {
  percentage: number
}

export const ProgressCar: React.FC<ProgressCarProps> = ({ percentage }) => (
  <Box
    style={{
      position: 'absolute',
      left: percentage < 10 ? 1 : `calc(${percentage}% - 36px)`,
      top: -35,
      width: 50,
      zIndex: 2,
    }}
  >
    <img
      src="/car.png"
      alt="progress-car"
      style={{
        width: '100%',
        height: 'auto',
        filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))',
      }}
    />
  </Box>
)

interface ProgressBarProps {
  percentage: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percentage }) => (
  <Box style={{ position: 'relative', width: '100%', marginBottom: 8 }}>
    <Progress.Root
      radius={12}
      size={16}
      style={{
        background: 'rgba(255, 90, 90, 0.1)',
        width: '100%',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Progress.Section
        value={percentage}
        style={{
          background: 'linear-gradient(90deg, #FFD700 0%, #FF8C00 50%, #FF5A5A 100%)',
        }}
      />
    </Progress.Root>
    <ProgressCar percentage={percentage} />
  </Box>
)
